// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"77b76ff8ebf10abc4963","339":"31c166ab9c2b119e4092"}[chunkId] + ".js";
};